import React from 'react';
import PropTypes from 'prop-types';
import Styles from './styled';
import Video from '../Video';
import Picture from '../Picture';
import Qzzr from '../Qzzr';
import ReactMarkdown from 'react-markdown';
import { useInView } from 'react-intersection-observer';

const ReusePostSections = ({ modules = [], isAnimated = true }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <Styles
      ref={ref}
      className={`block-reuse_content_modules ${isAnimated && 'isAnimated'} ${
        inView && 'active'
      }`}
    >
      <div className='inner'>
        {modules.map(
          (
            {
              mediaType,
              videoSource,
              embeddedContent,
              embeddedContentHeader,
              embeddedContentIntro,
              embeddedContentSubHeader,
              embeddedImage,
              embeddedContentPosition,
              ...props
            },
            i
          ) => (
            <div
              className={`module ${
                embeddedContentPosition === 'Above Intro' && 'module--reverse'
              }`}
              key={i}
            >
              {(embeddedContentHeader || embeddedContentSubHeader) &&
                embeddedContentPosition !== 'Above Intro' && (
                  <header>
                    {embeddedContentHeader && <h3>{embeddedContentHeader}</h3>}
                    {embeddedContentSubHeader && (
                      <h4 className='type-intro'>{embeddedContentSubHeader}</h4>
                    )}
                  </header>
                )}
              {embeddedContentIntro &&
                embeddedContentPosition !== 'Above Intro' && (
                  <ReactMarkdown source={embeddedContentIntro} />
                )}

              {mediaType === 'Video' ? (
                <Video
                  source={videoSource}
                  content={embeddedContent}
                  autoplay={false}
                  key={i}
                />
              ) : mediaType === 'Image' ? (
                <Picture
                  key={i}
                  src={`${embeddedImage?.fields?.file?.url}?w=808`}
                  alt={embeddedImage?.fields?.description}
                  isResponsive
                  sources={[
                    {
                      media: '(min-width: 1440px)',
                      params: '?w=808',
                      srcSet: embeddedImage?.fields?.file?.url,
                    },
                    {
                      media: '(min-width: 512px)',
                      params: '?w=512',
                      srcSet: embeddedImage?.fields?.file?.url,
                    },
                    {
                      media: '(max-width: 512px)',
                      params: '?w=300',
                      srcSet: embeddedImage?.fields?.file?.url,
                    },
                  ]}
                />
              ) : mediaType === 'Quiz' ? (
                <Qzzr id={embeddedContent} />
              ) : null}

              {(embeddedContentHeader || embeddedContentSubHeader) &&
                embeddedContentPosition === 'Above Intro' && (
                  <header>
                    {embeddedContentHeader && <h3>{embeddedContentHeader}</h3>}
                    {embeddedContentSubHeader && (
                      <h4 className='type-intro'>{embeddedContentSubHeader}</h4>
                    )}
                  </header>
                )}
              {embeddedContentIntro &&
                embeddedContentPosition === 'Above Intro' && (
                  <ReactMarkdown source={embeddedContentIntro} />
                )}
            </div>
          )
        )}
      </div>
    </Styles>
  );
};

ReusePostSections.propTypes = {
  modules: PropTypes.arrayOf(
    PropTypes.shape({
      mediaType: PropTypes.string,
      videoSource: PropTypes.string,
      embeddedContent: PropTypes.string,
      embeddedContentHeader: PropTypes.string,
      embeddedContentIntro: PropTypes.string,
      embeddedContentSubHeader: PropTypes.string,
      embeddedImage: PropTypes.shape({
        fields: PropTypes.shape({
          file: PropTypes.shape({
            url: PropTypes.string,
          }),
          description: PropTypes.string,
        }),
      }),
      embeddedContentPosition: PropTypes.string,
    })
  ),
};

export default ReusePostSections;
